var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularGaugeWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 20,
    fill: "none",
    stroke: "#333",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,25 m-20,0 a20,20 0 0,1 40,0",
    fill: "none",
    stroke: "#8a76db",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 30,
    textAnchor: "middle",
    fill: "#eee",
    fontFamily: "monospace",
    fontSize: 12
  }, "50%"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularGaugeWidget);
export default __webpack_public_path__ + "static/media/circular-gauge-widget.54d112d7f1ce1b2cdb36eb40f03db812.svg";
export { ForwardRef as ReactComponent };